<template>
<div v-if="aler===true">
     <div id="q-app" style="min-height: 100vh;">
  <div class="q-pa-md q-gutter-sm">
    <q-dialog v-model="aler">
      <q-card>
        <q-card-section>
          <div class="text-h6">PriceOptimization</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
         Price Prophet performs splendidly if there is a minimum of 6 months transaction details available for each product.
More the data, better the price suggestions.
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Ok, Got it" color="primary" v-close-popup></q-btn>
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</div>
 </div>
<div v-else>
  <div class="q-pa-md q-mt-xl">
    
    <q-table
      :loading="isLoading"
      ref="table"
      title="Product Selection"
      class="my-sticky-virtscroll-table"
      virtual-scroll
      :data="data"
      :columns="columns"
      row-key="variant"
      :virtual-scroll-sticky-size-start="55"
       selection="multiple"
      :selected.sync="selected"
      no-data-label="No Result Found"
    >
      <template v-slot:top-right>
        <q-input
          dense
          debounce="300"
          placeholder="Search"
          v-model="filter"
          @input="
            (val) => {
              searchHandler(val);
            }
          "
        >
          <q-icon slot="append" name="search" />
        </q-input>
      </template>

      <template v-slot:header="props">
        <q-tr :props="props">
          <q-th></q-th>
          <q-th
            v-for="col in columns"
            :key="col.name"
            :props="props"
            class="headerText"
            :style="{ fontSize: '15px', color: 'dodgerblue' }"
          >
            {{ col.label }}
          </q-th>
        </q-tr>
      </template>
      <template v-slot:body="props">
        <q-tr :props="props">
          <q-td>
            <q-checkbox v-model="props.selected" />
          </q-td>

          <!-- <q-td key="product" :props="props">
            {{ props.row.title }}
          </q-td> -->
          <q-td v-if="smallproduct(props.row.title,50)" key="product" :props="props"  class="text-left">
            <q-item
              dense
              dense-toggle
              expand-separator
              block
              :label= props.row.title 

            >
            {{ props.row.title }}

            </q-item>
          </q-td>

          <q-td v-else key="product" :props="props"  class="text-left">

            <q-expansion-item
              dense
              dense-toggle
              expand-separator
              :label=title(props.row.title,50)
            >
            <q-separator />

            <q-card>
              <q-card-section>
                {{ props.row.title }}
              </q-card-section>
            </q-card>
            </q-expansion-item>
          </q-td>

          <q-td key="variant" :props="props">
            {{ props.row.variant }}
          </q-td>
  
          <q-td key="shop" :props="props">
            {{ props.row.shop }}
          </q-td>

          <q-td key="compare_at_price" :props="props" class="text-right">
            <!-- {{ (props.row.currency=="INR"?"₹":"$") +" " + props.row.compare_at_price }} -->
             {{ currencySymbol[props.row.currency] +" " + props.row.compare_at_price }}
            <!-- {{getSymbolFromCurrency(props.row.currency)+' '+props.row.compare_at_price }} -->
          </q-td>

          <q-td key="price" :props="props" class="text-right">
             {{ currencySymbol[props.row.currency] +" " + props.row.price }}
          </q-td>

          <!-- <q-td key="input" :props="props" class="text-right">
            {{ currencySymbol[props.row.currency] +" " + props.row.input }}
            <q-popup-edit
              v-model.number="props.row.input"
              buttons
              :validate="carbsRangeValidation"
              @hide="carbsRangeValidation"
              label-set="ok"
            >
              <q-input
                type="number"
                v-model.number="props.row.input"
                hint="Enter a number greter than 0"
                :error="errorcarbs"
                :error-message="errorMessagecarbs"
                autofocus
              />
            </q-popup-edit>
          </q-td> -->
        </q-tr>
      </template>
    </q-table>

    <div class="priceOptButton">
      <button class="buttn" @click="optimise()">
        Add to Price Optimization
      </button>
    </div>
  </div>
  </div>
</template>

<style>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");
  .my-sticky-virtscroll-table {
  /* height or max-height is important */
  height: 430px;
  /* this will be the loading indicator */
}
.my-sticky-virtscroll-table .q-table__top,
.my-sticky-virtscroll-table .q-table__bottom,
.my-sticky-virtscroll-table thead tr:first-child th {
  background-color: #fff;
}
.my-sticky-virtscroll-table thead tr th {
  position: sticky;
  z-index: 1;
}
.my-sticky-virtscroll-table thead tr:last-child th {
  /* height of all previous header rows */
  top: 48px;
}
.my-sticky-virtscroll-table thead tr:first-child th {
  top: 0;
}
  h1{
  font-size:50px;
    margin:5% 7%;
    color:rgb(9, 111, 194);
}

.q-table__middle{
  overflow:auto;
  position:relative;
  height:350px;
  width:100%;
}
.errorClass {
  background: red;
}
.check {
  height: 1rem;
  margin-top: 1rem;
}
.priceOptButton {
  text-align: center;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  /* position: sticky; */
  bottom: 1rem;
}
.buttn {
  background: rgb(0, 88, 252);
  color: white;
  border-radius: 4px;
  border-color: white;
  height: 3rem;
  font-weight: 500;
  padding: 10px;
  background-color: #102689;
}
.buttn:hover {
  cursor: pointer;
}
.headerText {
  color: blue;
  font-weight: 800;
}
.fit{
   border-top-left-radius: 0px !important;
   border-bottom-right-radius: 0px !important;
   border-bottom-left-radius: 0px !important;
   background: white!important;
box-shadow: 0px 3px 6px #00000030;


}
</style>

<script>
import getSymbolFromCurrency from 'currency-symbol-map'
export default {
  data() {
    return {
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      isLoading: true,
      selectedRow: [],
      selected: [],
      aler:true,
      errorcarbs: false,
      errorClassData: [],
      errorMessagecarbs: "",
      submitVisibliliy: true,
      backupList: [],
      timeOut:true,
      revenue:null,
      columns: [
        {
          name: "product",
          required: true,
          label: "Product",
          align: "left",
          sortable: true,
          field: "title",
          required: true,
          headerStyle: "width: 500px",
        },
        {
          name: "variant",
          align: "center",
          label: "Variant",
          field: "variant",
          sortable: true,
        },

        { name: "shop", label: "Shop", align: "center" },
         { name: "compare_at_price", label: "Selling Price", align: "right" },
        { name: "price", label: "MRP", align: "right" },
        // {
        //   name: "input",
        //   label: "Input (minimun cost)",
        //   align: "center",
        // },
        
      ],
      filter: "",
      data: [],
      currencySymbol:{
  AED: 'د.إ',
  AFN: '؋',
  ALL: 'L',
  AMD: '֏',
  ANG: 'ƒ',
  AOA: 'Kz',
  ARS: '$',
  AUD: '$',
  AWG: 'ƒ',
  AZN: '₼',
  BAM: 'KM',
  BBD: '$',
  BDT: '৳',
  BGN: 'лв',
  BHD: '.د.ب',
  BIF: 'FBu',
  BMD: '$',
  BND: '$',
  BOB: '$b',
  BOV: 'BOV',
  BRL: 'R$',
  BSD: '$',
  BTC: '₿',
  BTN: 'Nu.',
  BWP: 'P',
  BYN: 'Br',
  BYR: 'Br',
  BZD: 'BZ$',
  CAD: '$',
  CDF: 'FC',
  CHE: 'CHE',
  CHF: 'CHF',
  CHW: 'CHW',
  CLF: 'CLF',
  CLP: '$',
  CNY: '¥',
  COP: '$',
  COU: 'COU',
  CRC: '₡',
  CUC: '$',
  CUP: '₱',
  CVE: '$',
  CZK: 'Kč',
  DJF: 'Fdj',
  DKK: 'kr',
  DOP: 'RD$',
  DZD: 'دج',
  EEK: 'kr',
  EGP: '£',
  ERN: 'Nfk',
  ETB: 'Br',
  ETH: 'Ξ',
  EUR: '€',
  FJD: '$',
  FKP: '£',
  GBP: '£',
  GEL: '₾',
  GGP: '£',
  GHC: '₵',
  GHS: 'GH₵',
  GIP: '£',
  GMD: 'D',
  GNF: 'FG',
  GTQ: 'Q',
  GYD: '$',
  HKD: '$',
  HNL: 'L',
  HRK: 'kn',
  HTG: 'G',
  HUF: 'Ft',
  IDR: 'Rp',
  ILS: '₪',
  IMP: '£',
  INR: '₹',
  IQD: 'ع.د',
  IRR: '﷼',
  ISK: 'kr',
  JEP: '£',
  JMD: 'J$',
  JOD: 'JD',
  JPY: '¥',
  KES: 'KSh',
  KGS: 'лв',
  KHR: '៛',
  KMF: 'CF',
  KPW: '₩',
  KRW: '₩',
  KWD: 'KD',
  KYD: '$',
  KZT: '₸',
  LAK: '₭',
  LBP: '£',
  LKR: '₨',
  LRD: '$',
  LSL: 'M',
  LTC: 'Ł',
  LTL: 'Lt',
  LVL: 'Ls',
  LYD: 'LD',
  MAD: 'MAD',
  MDL: 'lei',
  MGA: 'Ar',
  MKD: 'ден',
  MMK: 'K',
  MNT: '₮',
  MOP: 'MOP$',
  MRO: 'UM',
  MRU: 'UM',
  MUR: '₨',
  MVR: 'Rf',
  MWK: 'MK',
  MXN: '$',
  MXV: 'MXV',
  MYR: 'RM',
  MZN: 'MT',
  NAD: '$',
  NGN: '₦',
  NIO: 'C$',
  NOK: 'kr',
  NPR: '₨',
  NZD: '$',
  OMR: '﷼',
  PAB: 'B/.',
  PEN: 'S/.',
  PGK: 'K',
  PHP: '₱',
  PKR: '₨',
  PLN: 'zł',
  PYG: 'Gs',
  QAR: '﷼',
  RMB: '￥',
  RON: 'lei',
  RSD: 'Дин.',
  RUB: '₽',
  RWF: 'R₣',
  SAR: '﷼',
  SBD: '$',
  SCR: '₨',
  SDG: 'ج.س.',
  SEK: 'kr',
  SGD: 'S$',
  SHP: '£',
  SLL: 'Le',
  SOS: 'S',
  SRD: '$',
  SSP: '£',
  STD: 'Db',
  STN: 'Db',
  SVC: '$',
  SYP: '£',
  SZL: 'E',
  THB: '฿',
  TJS: 'SM',
  TMT: 'T',
  TND: 'د.ت',
  TOP: 'T$',
  TRL: '₤',
  TRY: '₺',
  TTD: 'TT$',
  TVD: '$',
  TWD: 'NT$',
  TZS: 'TSh',
  UAH: '₴',
  UGX: 'USh',
  USD: '$',
  UYI: 'UYI',
  UYU: '$U',
  UYW: 'UYW',
  UZS: 'лв',
  VEF: 'Bs',
  VES: 'Bs.S',
  VND: '₫',
  VUV: 'VT',
  WST: 'WS$',
  XAF: 'FCFA',
  XBT: 'Ƀ',
  XCD: '$',
  XOF: 'CFA',
  XPF: '₣',
  XSU: 'Sucre',
  XUA: 'XUA',
  YER: '﷼',
  ZAR: 'R',
  ZMW: 'ZK',
  ZWD: 'Z$',
  ZWL: '$'
},
    };
  },
  mounted() {
    // setTimeout(()=>{
    //    this.timeOut = false;
    // },5000)
     
    var productsURL = this.api_url + "/products/product_display";
    this.$http
      .get(productsURL)
      .then((response) => {
        let result = response.data;
        console.log(result)

        let data = result.map((items) => {
          return {
            ...items,
            input: items.compare_at_price ? items.compare_at_price : 0,
          };
        });
        console.log(data);

        this.data = data;

        this.backupList = data;
        this.isLoading = false;
      })
      .catch((err) => {
        this.$q.notify({
          message: err,
          color: "negative",
        });
        this.isLoading = false;
        //console.log(err);
      });
  },
  created(){
      this.$q.loading.show({
       message: "Authenticating please wait..",
     });

      if(this.$cookies.isKey("login_authentication"))
     {
       let encryptedText = this.$cookies.get("login_authentication");

       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);

       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$q.loading.hide();
          this.$store.dispatch("setPathName", "/priceoptimization/volume?type=volume");
        this.isAuthenticated = true;

       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;

       }
       

     }
     else if(this.$cookies.isKey("login_authentication1"))
     {
       let encryptedText = this.$cookies.get("login_authentication1");

       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);

       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
        this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;

       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;

       }
       

     }
     else if(this.$cookies.isKey("login_authentication2"))
     {
       let encryptedText = this.$cookies.get("login_authentication2");

       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);

       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$q.loading.hide();
          this.$store.dispatch("setPathName", "/priceoptimization/volume?type=volume");
        this.isAuthenticated = true;

       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;

       }
       

     }
     else{

       this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;

     }

    },
  
  // created() {
  //   var productsURL = this.api_url + "/products/product_display";
  //   this.$http
  //     .get(productsURL)
  //     .then((response) => {
  //       let result = response.data;
  //       console.log(result)

  //       let data = result.map((items) => {
  //         return {
  //           ...items,
  //           input: items.compare_at_price ? items.compare_at_price : 0,
  //         };
  //       });
  //       console.log(data);

  //       this.data = data;

  //       this.backupList = data;
  //       this.isLoading = false;
  //     })
  //     .catch((err) => {
  //       this.$q.notify({
  //         message: err,
  //         color: "negative",
  //       });
  //       this.isLoading = false;
  //       //console.log(err);
  //     });
  // },
  // mounted() {
  //   setTimeout(() => {
  //     let data = this.exampleData.map((items) => {
  //       return {
  //         ...items,
  //         input: items.priceCost ? items.priceCost : 0 ,
  //       };
  //     });
  //     this.data = data;
  //     this.backupList = data;
  //     this.isLoading = false;
  //   }, 1000);
  // },
  methods: {
    searchHandler(value) {
      if (value.length >= 3) {
        let searchResult = this.backupList.filter((item) => {
          return item.title.toLowerCase().includes(value.toLowerCase());
        });
        this.data = searchResult;
      } else {
        this.data = this.backupList;
      }
    },
     smallproduct(value,size){
       if (value.length <= size) {
        return 1;
      }
    },
    title(value,size){
      if (!value) return '';
      value = value.toString();
      if (value.length <= size) {
        return value;
      }
      else{
       return value.substr(0,size) + '...'; 
      } 
    },

    optimiseApiCall(selectedProductList) {
     const product_list = selectedProductList.map((product) => (
        {
            "product": product.title,
            "product_variant": product.variant,
            "min_cost_price": product.price
        }
    ));
    const type = this.$route.query.type;
    return [{"product_list":product_list,"type":type, "mode":"online"}]
    },

    optimise() {
      if (this.selected.length === 0) {
        this.$q.notify({
          message: "Please select atleast one product",
          color: "grey-3",
          textColor: "blue",
        });
        // console.log("Please select atleast one product");
      } else {
        this.errorClassData = this.selected.filter((product) => {
          //console.log(product.input);
          return product.input == null || product.input == 0;
        });
        if (this.errorClassData == 0) {
          this.$q.notify({
            message: "Processing",
            color: "grey-3",
            textColor: "blue",
          });
          // console.log("Calling API");
          // window.location.href = "/";
          let postURL = this.api_url + `/products/trigger_price_optimization/` + this.$org_id.label;
          // console.log(this.optimiseApiCall(this.selected))
          this.$http
            .post(postURL, this.optimiseApiCall(this.selected))
            .then((response) => {
              if (response.data) {
                
                this.$q.notify({
                  message: "Added to optimization",
                  color: "grey-3",
                  textColor: "blue",
                });
                // setTimeout(() => {
                //  this.$router.push({path: '/recommendations'});
                // }, 1000);
                this.$router.push({
                  name: "PriceOptimizationHistory",
                });
                // setTimeout(() => {
                //   window.location.href =
                //     "/priceoptimization/revenue/recommendations";
                // }, 1000);

                // calling other route with unique id
                // console.log(response.data);
              } else {
                this.$q.notify({
                  message: "Error Occured!",
                  color: "grey-5",
                  textColor: "negative",
                });
              }
            })
            .catch((e) => {
              this.$q.notify({
                message: e.message,
                color: "grey-5",
                textColor: "negative",
              });
            });
        }
         
        //else {
        //   this.errorClassData = [];
        //   this.$q.notify({
        //     message: "please check selected Input (minimun cost)",
        //     color: "grey-5",
        //     textColor: "negative",
        //   });

        //   console.error("please check selected Input (minimun cost)");
        // }
      }
    },
  },
};
</script>
